import styled, { css } from 'styled-components';
import { getGridSpans, mq, getSpace, getTextType } from '../../../stylesheets/tools';

const StyledContactList = styled.div`
  .contactList__list {
    display: flex;
    flex-wrap: wrap;
    margin: 0;
    padding: 0;
    list-style-type: none;
  }

  .contactList__person {
    ${getGridSpans('width', { s: 12, l: 9 })}
    ${getGridSpans('margin-left', { s: 0, l: [1, 'spread'] })}
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin: 30px 0;
    padding-top: 50px;

    ${mq('m')} {
      padding-top: 0;
    }

    &:after {
      position: absolute;
      width: 100%;
      content: '';
      height: 2px;
      top: 0;
      left: 0;
      background: #000;

      ${mq('m')} {
        top: auto;
        bottom: 0;
      }
    }
  }

  .contactList__headline {
    ${getGridSpans('width', { s: 12, m: [5, 'normal', 12], l: [4, 'spread', 9] })}

    ${mq('m')} {
      padding: 10px 10px 10px 0;
    }

    p {
      margin: ${getSpace('xs')} 0;

      ${mq('m')} {
        margin-bottom: 0;
      }
    }
  }

  .contactList__contact {
    ${getGridSpans('width', { s: 12, m: [7, 'normal', 12], l: [5, 'normal', 9] })}

    ${mq('m')} {
      padding: 10px;
    }

    a {
      width: 100%;
      display: inline;
      margin: ${getSpace('xxs')} 0;
      font-weight: 700;
      ${getTextType('copy', 'international')}

      span {
        display: none;
      }

      &:hover {
        span {
          border-bottom: 1px solid #000;
        }
      }

      ${mq('m')} {
        display: block;

        span {
          display: inline-block;
        }
      }

      ${mq('l')} {
        margin: ${getSpace('xs')} 0;
      }
    }

    svg {
      width: 25px;
      height: 25px;
      margin-right: 20px;

      ${mq('l')} {
        margin-right: ${getSpace('xxs')};
        width: 33px;
        height: 33px;
      }
    }
  }

  .contactList__person--hasImage {
    ${getGridSpans('width', { s: 12, l: 11 })}
    ${getGridSpans('margin-left', { s: 0, l: [1, 'spread'] })}
    padding-top: 0;

    .contactList__headline {
      ${getGridSpans('width', { s: 12, m: [5, 'normal', 12], l: [4, 'spread', 11] })}
    }

    .contactList__contact {
      ${getGridSpans('width', { s: 12, m: [4, 'spread', 12], l: [4, 'spread', 11] })}
    }
  }

  .contactList__image {
    order: -1;
    ${getGridSpans('width', { s: 12, m: [3, 'normal', 12], l: [3, 'normal', 11] })}
    z-index: 1;
    overflow: hidden;
    position: relative;
    top: -${getSpace('xs')};

    ${mq('m')} {
      order: 0;
      top: auto;
      bottom: -20px;
    }

    .contactList__image-wrapper {
      position: relative;
      float: right;
      margin-right: ${getSpace('xxs')};

      ${mq('m')} {
        float: none;
      }

      &:before {
        position: absolute;
        content: '';
        top: 0;
        left: 0;
        width: 15px;
        height: 21px;
        background: #fff;
        transform: rotate(45deg);
        transform-origin: top right;
      }
    }

    img {
      max-width: 160px;
      width: 100%;
      height: auto;
      border-radius: 6px;

      ${mq('m')} {
        max-width: 220px;
      }
    }
  }

  ${props =>
    props.insideAccordion &&
    css`
      .contactList__person,
      .contactList__person--hasImage {
        ${getGridSpans('width', { s: 12, l: 12 })}
        ${getGridSpans('margin-left', { s: 0, l: 0 })}

        &:after {
          ${mq('m')} {
            top: 0;
            bottom: auto;
          }
        }

        .contactList__headline {
          ${getGridSpans('width', { l: [5, 'spread', 12] })}
        }

        .contactList__contact {
          ${getGridSpans('width', { l: [4, 'spread', 12] })}
        }

        .contactList__image {
          ${getGridSpans('width', { l: [3, 'normal', 12] })}
          ${mq('m')} {
            order: 0;
            top: -${getSpace('xs')};
            bottom: auto;
          }
        }

        .contactList__image-wrapper {
          margin-right: 0;
        }
      }
    `}
`;

export default StyledContactList;
